import React from "react";
import { num } from "@/lib/format";
import { CalendarDays, Clock, Zap, UtensilsCrossed, Moon, BedDouble } from "lucide-react";

export function RiepilogoOre({ ore = [], rimborsi = [], trasferte = [], titolo }) {
  const giorni = new Set(ore.map((o) => (o.data || "").slice(0, 10))).size;
  const ord = ore.filter((o) => o.tipo !== "straordinario").reduce((s, o) => s + (o.ore || 0), 0);
  const str = ore.filter((o) => o.tipo === "straordinario").reduce((s, o) => s + (o.ore || 0), 0);
  const pasti = rimborsi.filter((r) => r.tipo === "pranzo_cantiere").length;
  const cene = rimborsi.filter((r) => r.tipo === "cena_trasferta").reduce((s, r) => s + (r.notti || 1), 0);
  const notti = trasferte.reduce((s, t) => s + (t.notti || 0), 0);
  const voci = [
    { k: "giorni", label: "Giorni lavorati", v: num(giorni, 0), icon: CalendarDays, cls: "text-slate-900" },
    { k: "ordinarie", label: "Ore ordinarie", v: `${num(ord, 1)} h`, icon: Clock, cls: "text-slate-900" },
    { k: "straordinarie", label: "Ore straordinarie", v: `${num(str, 1)} h`, icon: Zap, cls: "text-primary" },
    { k: "pasti", label: "Pasti cantiere", v: num(pasti, 0), icon: UtensilsCrossed, cls: "text-amber-700" },
    { k: "cene", label: "Cene trasferta", v: num(cene, 0), icon: Moon, cls: "text-sky-700" },
    { k: "notti", label: "Notti fuori sede", v: num(notti, 0), icon: BedDouble, cls: "text-emerald-700" },
  ];
  return (
    <div className="space-y-2" data-testid="ore-riepilogo">
      {titolo && <div className="text-xs font-semibold uppercase tracking-wider text-slate-500" data-testid="ore-riepilogo-titolo">{titolo}</div>}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {voci.map(({ k, label, v, icon: Icon, cls }) => (
        <div key={k} className="rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2.5" data-testid={`ore-riepilogo-${k}`}>
          <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            <Icon className="h-3.5 w-3.5" /> {label}
          </div>
          <div className={`font-mono text-xl font-semibold mt-1 ${cls}`}>{v}</div>
        </div>
      ))}
      </div>
    </div>
  );
}
